// Random state stored in sessionStorage, verified in Home.jsx to prevent login-CSRF
export function buildStravaUrl(force = false) {
  const state = Array.from(crypto.getRandomValues(new Uint8Array(16)))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("");
  sessionStorage.setItem("oauthState", state);

  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_STRAVA_CLIENT_ID,
    response_type: "code",
    redirect_uri: `${process.env.REACT_APP_FRONTEND_URL}/`,
    scope: "read,activity:read_all",
    state
  });
  // Forceert het toestemmingsscherm altijd te tonen — gebruikt om de koppeling
  // te herstellen als Strava een te beperkte scope had onthouden.
  if (force) params.set("approval_prompt", "force");
  return `https://www.strava.com/oauth/authorize?${params}`;
}
